<script lang="ts">
	import { toastStore } from '$lib/stores/toast-store'
	import Toast from './Toast.svelte'
	import { fly } from 'svelte/transition'

	interface Props {
		isMobileScreen?: boolean
	}

	let { isMobileScreen = false }: Props = $props()

	// Subscribe to the toast store
	let toasts = $derived($toastStore)

	function handleDismiss(id: string) {
		toastStore.remove(id)
	}
</script>

{#if isMobileScreen}
	<div class="fixed left-0 right-0 top-2 transform z-50 flex flex-col gap-y-2 w-full mx-auto px-2">
		{#each toasts as toast (toast.id)}
			<div in:fly={{ y: 50, duration: 300 }} out:fly={{ y: 50, duration: 300 }}>
				<Toast {toast} ondismiss={handleDismiss} />
			</div>
		{/each}
	</div>
{:else}
	<div class="fixed right-4 top-4 transform z-50 flex flex-col gap-2 w-full max-w-sm px-4">
		{#each toasts as toast (toast.id)}
			<div in:fly={{ y: 50, duration: 300 }} out:fly={{ y: 50, duration: 300 }}>
				<Toast {toast} ondismiss={handleDismiss} />
			</div>
		{/each}
	</div>
{/if}
